module.exports = __webpack_public_path__ + "produkte.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/menu/produkte.svg
// module id = 119
// module chunks = 0